// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2cXzC","footer":"Form_footer__17Flt"};